module.exports = __webpack_public_path__ + "img/tablet-landscape.ea9a311c.svg";